import styles from './OptionChainTableDesktop.module.scss';
import MiddleComponent from './OptionChainMiddle';
import TableHead from './TableHead';
import TableRow from './TableRow';
import { CallsAndPuts } from '@benzinga/data-option-chain';
import { OptionTableColumnsProps } from './types';
interface Data {
  call: CallsAndPuts;
  put: CallsAndPuts;
}

interface OptionChainTableDesktopProps {
  data: Data[];
  optionTableColumns: OptionTableColumnsProps[];
}

const OptionChainTableDesktop = ({ data, optionTableColumns }: OptionChainTableDesktopProps) => {
  return (
    <div>
      <div className="hidden md:flex border-t justify-between">
        <TableHead className="border border-[#e1ebfa] border-r-0" columns={optionTableColumns} />
        <MiddleComponent text="Strike" type="top" variant="title" />
        <TableHead className="border border-[#e1ebfa] border-l-0" columns={optionTableColumns} />
      </div>
      {data?.map((item: Data, index: number) => {
        return (
          <div className={`${styles.optionChainTableContainer} flex justify-between`} key={index}>
            <TableRow className={item.call?.inTheMoney ? 'border-left' : ''} values={item.call} />
            <MiddleComponent text={item.call?.strike} type="middle" variant="value" />
            <TableRow className={item.put?.inTheMoney ? 'border-right' : ''} values={item.put} />
          </div>
        );
      })}
    </div>
  );
};

export default OptionChainTableDesktop;
